module.exports = __webpack_public_path__ + "static/media/Dental.6d58a8ba.svg";